import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';
import { notify } from 'src/components/notify';

const deleteCampianGroup = async (user, id) => {
    try {
        const storageAvailable = localStorageAvailable();
        const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

        const config = {
            method: 'delete',
            maxBodyLength: Infinity,
            url: `/service/accounts_service/v1/accounts/wa/number/group/${id}`,
            headers: {
                authorization: `Bearer ${accessToken}`,
                user,
            },
        };
        const response = await axios.request(config);
        return response.data;
    } catch (err) {
        return notify(err?.message || err?.issues[0]?.message)

    }
};

export default deleteCampianGroup;
